import "./utilities_namespace.js";
import "./manipulate_input/input_element.js";
import "./manipulate_input/checkbox.js";
import "./manipulate_input/radio.js";

window.Sparkle ??= {};
window.Sparkle.Utilities ??= {};

window.Sparkle.Utilities.getInputValue = function (input) {
  input = jQuery(input);
  if (input.is(":checkbox")) {
    return new ManipulateCheckbox(input).getValue();
  } else if (input.is(":radio")) {
    return new ManipulateRadio(input).getValue();
  } else if (input.is(":input, sp-select")) {
    return new ManipulateInputElement(input).getValue();
  } else {
    return input.attr("value");
  }
};
